import MembershiptypesDashboardDiagrams from './membershiptypes-dashboard-diagrams';
export default MembershiptypesDashboardDiagrams;
